import React from 'react';
import PropTypes from 'prop-types';

import { Banner } from '@buildoutinc/blueprint-react/ui/Banner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

import ListingSelector from './listing_selector';
import ProjectSelector from './project_selector';
import PropertySelector from './property_selector';

export default function ListingSearchForm({
  confirmationMessage,
  deal,
  edgeCrm,
  listing,
  project,
  propertyIdOverride,
  onListingChange,
  onProjectChange,
  onPropertyIdOverrideChange,
}) {
  if (confirmationMessage) {
    return (
      <Banner className="align-items-center" variant="warning">
        <Banner.Content>
          <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          {confirmationMessage}
        </Banner.Content>
      </Banner>
    );
  }

  return (
    <div className="d-flex flex-column gap-3">
      <ProjectSelector
        deal={deal}
        project={project}
        onChange={onProjectChange}
      />

      {edgeCrm && (
        <PropertySelector
          deal={deal}
          project={project}
          propertyId={propertyIdOverride}
          onSelect={onPropertyIdOverrideChange}
        />
      )}

      <ListingSelector
        deal={deal}
        listing={listing}
        project={project}
        onChange={onListingChange}
      />
    </div>
  );
}

ListingSearchForm.propTypes = {
  confirmationMessage: PropTypes.string,
  deal: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  listing: PropTypes.object,
  project: PropTypes.object,
  propertyIdOverride: PropTypes.number,
  onListingChange: PropTypes.func.isRequired,
  onProjectChange: PropTypes.func.isRequired,
  onPropertyIdOverrideChange: PropTypes.func.isRequired,
};
